import { Card, Col, Pagination, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TailwindButton from "components/Button";
import { CreateCreatifyVideoFromLink, GetAiAvatar } from "./CreatifyAPI";
import { headerStyles, stepsEnum } from "./options";
import MediaSelectorCard from "./MediaSelectorCard";

const defaultFn = () => { };

const StepThree = ({
  cachedData,
  loading = false,
  onNext = defaultFn,
  setLoading = defaultFn,
}) => {
  const { t } = useTranslation();
  const [aiAvatar, setAiAvatar] = useState([]);
  const [selectedAvatarId, setSelectedAvatarId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [prevPage, setPrevPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const recordsPerPage = 12;

  const getAiAvatar = async () => {
    try {
      setIsLoading(true);
      const result = await GetAiAvatar({
        page: currentPage,
        page_size: recordsPerPage,
      });
      setAiAvatar(result?.results);
      setTotalPages(result?.count);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    // "https://1690-182-180-162-166.ngrok-free.app/api/v1/"
    try {
      setLoading(true);
      const createLinkPayload = {
        ...cachedData?.stepTwo,
        payloadContentId: cachedData?.stepOne?.id,
        link: cachedData?.stepOne?.id,
        override_avatar: selectedAvatarId,
        webhook_url: process.env.REACT_APP_BASE_API_URL + "creatify-api/update-creatify-video-creation-status"
      }
      const result = await CreateCreatifyVideoFromLink(createLinkPayload);
      onNext(stepsEnum.stepFour, result);
    } catch (err) {
    }
    finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setPrevPage(currentPage);
    setCurrentPage(page);
  };

  useEffect(() => {
    setIsLoading(true);
    getAiAvatar();
  }, []);

  useEffect(() => {
    if (prevPage !== currentPage) {
      getAiAvatar();
    }
  }, [currentPage]);

  useEffect(() => {
    if (cachedData?.stepThree?.override_avatar) {
      setSelectedAvatarId(cachedData?.stepThree?.override_avatar);
    }
  }, [cachedData?.stepThree?.override_avatar]);

  return (
    <Card title={t("Avatar Selection")} headStyle={headerStyles}>
      <Row gutter={[16, 16]} className="pb-4 w-full">
        {isLoading
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map((item, index) => (
            <Col xs={12} sm={8} md={4} lg={4} xl={4} key={index}>
              <MediaSelectorCard
                isSelected={false}
                isMaxLimitReached={false}
                handleSelectMedia={() => { }}
              />
            </Col>
          ))
          : aiAvatar?.map((avatar, index) => {
            const tags = [
              avatar?.age_range,
              avatar?.style,
              avatar?.location,
              avatar?.type,
            ];
            return (
              <Col xs={12} sm={8} md={4} lg={4} xl={4} key={avatar.id}>
                <MediaSelectorCard
                  url={avatar?.squared_preview_video}
                  isSelected={selectedAvatarId === avatar?.id}
                  isMaxLimitReached={false}
                  handleSelectMedia={() => {
                    setSelectedAvatarId(avatar?.id);
                  }}
                  tags={tags}
                  showPreviewIcon={true}
                />
              </Col>
            );
          })}
      </Row>
      <div className="flex justify-between w-full">
        {(totalPages && totalPages > 0 && totalPages > recordsPerPage) ? (
          <Pagination
            defaultCurrent={currentPage}
            showSizeChanger={false}
            showQuickJumper={true}
            defaultPageSize={recordsPerPage}
            total={totalPages}
            onChange={handlePageChange}
            disabled={isLoading || loading}
          />
        ):<div className="h-10 w-10"/>}
        <div className="flex justify-end me-2">        
          <TailwindButton
          text={"Save & Continue"}
          disabled={!selectedAvatarId || loading || isLoading}
          // formId="stepThreeForm"
          onClick={handleSubmit}
        />
        </div>

      </div>
    </Card>
  );
};

export default StepThree;
